// extracted by mini-css-extract-plugin
export default {"history-rewards":"styles_history-rewards__jHYfa"};